export default __webpack_public_path__ + "static/media/advert-blue-1.8e6205d3.png";